/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "./translate";
import {
  setQryStrMedium,
  setQryStrSource,
} from "./redux/queryStrings/queryStringsActions";

import { RootTabsContainer } from "@afg-ikea/ikea-family-registration-module/dist";
import "./App.scss";

function App() {
  const dispatch = useDispatch();
  const i18n = useTranslate();
  const { getCurrentLanguage } = i18n;
  const mediumFromStore = useSelector(
    ({ queryStrings }) => queryStrings.medium
  );
  const sourceFromStore = useSelector(
    ({ queryStrings }) => queryStrings.source
  );
  const [lang, setLang] = useState("");
  useEffect(() => {
    document.addEventListener("contextmenu", (event) => event.preventDefault());
    const queryString = window.location.search;
    const parameters = new URLSearchParams(queryString);
    const medium = parameters.get("utm_medium");
    const source = parameters.get("utm_source");
    dispatch(setQryStrMedium(medium));
    dispatch(setQryStrSource(source));
    setLang(parameters.get("lang"));
  }, []);

  const currLocale = lang
    ? lang
    : document.documentElement.lang
    ? document.documentElement.lang
    : getCurrentLanguage();

  return (
    <>
      {lang && lang === "ar-QA" ? (
        <div dir="rtl">
          <RootTabsContainer
            medium={mediumFromStore}
            source={sourceFromStore}
            locale={currLocale}
          />
        </div>
      ) : (
        <RootTabsContainer
          medium={mediumFromStore}
          source={sourceFromStore}
          locale={currLocale}
        />
      )}
    </>
  );
}

export default App;
